import React, { useState } from 'react';
import { ChevronDown, ChevronUp, MapPin, Calendar, Car } from 'lucide-react';

const MobileOrderSummary = ({ bookingDetails }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  };

  return (
    <div className="bg-secondary rounded-xl border border-border overflow-hidden">
      {/* Collapsed Header */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-4 py-3 flex items-center justify-between"
      >
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium text-foreground">Order Summary</span>
          <span className="text-primary font-display font-bold">
            {bookingDetails.currency}{bookingDetails.price}
          </span>
        </div>
        {isExpanded ? (
          <ChevronUp className="h-5 w-5 text-muted-foreground" />
        ) : (
          <ChevronDown className="h-5 w-5 text-muted-foreground" />
        )}
      </button>

      {/* Expanded Content */}
      {isExpanded && (
        <div className="px-4 pb-4 pt-2 border-t border-border space-y-3">
          <div className="flex items-start gap-2">
            <MapPin className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
            <div className="text-sm">
              <span className="text-foreground">{bookingDetails.pickup}</span>
              <span className="text-muted-foreground mx-1">→</span>
              <span className="text-foreground">{bookingDetails.dropoff}</span>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <Calendar className="h-4 w-4 text-muted-foreground flex-shrink-0" />
            <span className="text-sm text-foreground">
              {formatDate(bookingDetails.date)} at {bookingDetails.time}
            </span>
          </div>
          
          <div className="flex items-center gap-2">
            <Car className="h-4 w-4 text-muted-foreground flex-shrink-0" />
            <span className="text-sm text-foreground">{bookingDetails.vehicleName}</span>
          </div>
          
          <div className="pt-2 border-t border-border flex items-center justify-between">
            <span className="text-sm font-medium text-foreground">Total</span>
            <div className="flex items-baseline gap-0.5">
              <span className="text-xs text-muted-foreground">{bookingDetails.currency}</span>
              <span className="font-display text-xl font-bold text-foreground">{bookingDetails.price}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileOrderSummary;
